import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ImageCropperModule } from 'ngx-image-cropper';
import { RouterModule, Routes} from '@angular/router';
import { AngularFireModule} from '@angular/fire';
import { environment } from 'src/environments/environment';
import { AngularFirestoreModule} from '@angular/fire/firestore';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BsDatepickerModule, TooltipModule, ModalModule } from 'ngx-bootstrap';

import {AuthenticationGuard} from './services/authentication.guard';

import { SavehtmlPipe } from './pipes/savehtml';

import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { RecoverypassComponent } from './recoverypass/recoverypass.component';
import { ProductsComponent } from './products/products.component';
import { ContactComponent } from './contact/contact.component';
import { MenuComponent } from './menu/menu.component';
import { StoreComponent } from './store/store.component';
import { UtilitiesComponent } from './utilities/utilities.component';
import { ProjectsComponent } from './projects/projects.component';
import { AddprojectComponent } from './addproject/addproject.component';
import { ProjectComponent } from './project/project.component';
import { PlansComponent } from './plans/plans.component';
import { DescriptionComponent } from './description/description.component';
import { ActivateComponent } from './activate/activate.component';
import { ActivateproductComponent } from './activateproduct/activateproduct.component';
import { ActivatedescriptionComponent } from './activatedescription/activatedescription.component';
import { IntellectualpropertyComponent } from './intellectualproperty/intellectualproperty.component';


const appRoutes: Routes = [
  {path: '', component: HomeComponent, canActivate: [AuthenticationGuard]},
  {path: 'home', component: HomeComponent, canActivate: [AuthenticationGuard]},
  {path: 'login', component: LoginComponent},
  {path: 'contact', component: ContactComponent, canActivate: [AuthenticationGuard]},
  {path: 'products', component: ProductsComponent, canActivate: [AuthenticationGuard]},
  {path: 'recoverypass', component: RecoverypassComponent},
  {path: 'store', component: StoreComponent, canActivate: [AuthenticationGuard]},
  {path: 'projects', component: ProjectsComponent, canActivate: [AuthenticationGuard]},
  {path: 'addproject', component: AddprojectComponent, canActivate: [AuthenticationGuard]},
  {path: 'project/:pid', component: ProjectComponent, canActivate: [AuthenticationGuard]},
  {path: 'description/:pid', component: DescriptionComponent, canActivate: [AuthenticationGuard]},
  {path: 'plans', component: PlansComponent, canActivate: [AuthenticationGuard]},
  {path: 'activate', component: ActivateComponent, canActivate: [AuthenticationGuard]},
  {path: 'activateproduct/:pid/:uid/:action', component: ActivateproductComponent, canActivate: [AuthenticationGuard]},
  {path: 'intellectualproperty', component: IntellectualpropertyComponent, canActivate: [AuthenticationGuard]}
  ];
@NgModule({
  declarations: [
    AppComponent,
    SavehtmlPipe,
    LoginComponent,
    HomeComponent,
    RecoverypassComponent,
    ProductsComponent,
    ContactComponent,
    MenuComponent,
    StoreComponent,
    UtilitiesComponent,
    ProjectsComponent,
    AddprojectComponent,
    ProjectComponent,
    PlansComponent,
    DescriptionComponent,
    ActivateComponent,
    ActivateproductComponent,
    ActivatedescriptionComponent,
    IntellectualpropertyComponent
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(appRoutes),
    FormsModule,
    ReactiveFormsModule.withConfig({warnOnNgModelWithFormControl: 'never'}),
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    AngularFireAuthModule,
    AngularFireStorageModule,
    AngularFireDatabaseModule,
    BrowserAnimationsModule,
    BsDatepickerModule.forRoot(),
    TooltipModule.forRoot(),
    ModalModule.forRoot(),
    ImageCropperModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
